/* eslint-disable no-underscore-dangle */

import uniqid from 'uniqid'
import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { formatDateLocalized } from '../utils'

type RatingsCellProps = {
  cellProps: any
  displayLocalValues: boolean
  handleClick: (rowIndex: number, ratableId: string) => void
  isActive: boolean
  isOpen?: boolean
  showRatingHistory?: boolean
}

type RatingCodeFuncProps = {
  item: any
}
const DATE_FORMAT = 'dd-MMM-yyyy'

export const ratingsFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { language, ratableRatings, recoveryEstimate } = data._original
  let result = false
  let ratableRatingsResult = false

  /* eslint no-unused-expressions: [2, { allowShortCircuit: true }] */
  ratableRatings &&
    ratableRatings.forEach((item: any) => {
      const ratingActionDescription =
        item.ratingActionDescription &&
        item.ratingActionDescription.toLowerCase().includes(filter)
      const ratingCode =
        item.ratingCode && item.ratingCode.toLowerCase().includes(filter)
      const ratingLocalValue =
        item.ratingLocalValue &&
        item.ratingLocalValue.toLowerCase().includes(filter)
      const ratingLocalActionDescription =
        item.ratingLocalActionDescription &&
        item.ratingLocalActionDescription.toLowerCase().includes(filter)
      const ratingEffectiveDate =
        item.ratingEffectiveDate &&
        formatDateLocalized(item.ratingEffectiveDate, DATE_FORMAT, language)
          .toLowerCase()
          .includes(filter)
      const ratingTypeDescription =
        item.ratingTypeDescription &&
        item.ratingTypeDescription.toLowerCase().includes(filter)
      const recoveryEstimateFil =
        item.recoveryEstimate &&
        item.recoveryEstimate.toLowerCase().includes(filter)
      const recoveryRatingValue =
        item.recoveryRatingValue &&
        item.recoveryRatingValue.toLowerCase().includes(filter)
      const ratingAlertCode =
        item.ratingAlertCode &&
        item.ratingAlertCode.toLowerCase().includes(filter)
      const ratingCorrectionText = item.correctionFlag
        ? `Rating Correction ${formatDateLocalized(
            item.changeDate,
            DATE_FORMAT,
            language
          )}`
        : ''
      const ratingsCorrection =
        item.correctionFlag &&
        ratingCorrectionText.toLowerCase().includes(filter)
      if (
        ratingActionDescription ||
        ratingCode ||
        ratingLocalValue ||
        ratingLocalActionDescription ||
        ratingEffectiveDate ||
        ratingTypeDescription ||
        recoveryEstimateFil ||
        recoveryRatingValue ||
        ratingAlertCode ||
        ratingsCorrection
      ) {
        ratableRatingsResult = true
      }
    })
  if (
    ratableRatingsResult ||
    (recoveryEstimate && recoveryEstimate.toLowerCase().includes(filter))
  ) {
    result = true
  }

  return result
}
const RatingCodeFunc = ({ item }: RatingCodeFuncProps) => {
  const isRatAlertCode = `${
    item.ratingAlertCode
      ? `<span class=${item.ratingAlertCode.replace(':', '')}></span>`
      : ''
  }`
  return (
    <>
      {item.ratingCode
        ? ReactHtmlParser(
            `<span class=${item.orangeDisplay ? 'eu-rating-text' : ''}>
          ${item.displayLocalValues ? item.ratingLocalValue : item.ratingCode}
        </span>
        ${isRatAlertCode}
        <br />`
          )
        : null}
    </>
  )
}

export class RatingsCell extends React.Component<RatingsCellProps> {
  historyClick = (rowIndex: number, ratableId: string) => {
    const { handleClick } = this.props
    handleClick(rowIndex, ratableId)
  }

  render() {
    const {
      cellProps,
      displayLocalValues,
      showRatingHistory = true
    } = this.props
    const { row } = cellProps
    const { language, ratableRatings, recoveryEstimate } = cellProps.original
    const rowIndex = row._index
    const ratableId = row._original.id

    return (
      <>
        {ratableRatings.map((item: any) => (
          <React.Fragment key={uniqid()}>
            {item.ratingEffectiveDate
              ? ReactHtmlParser(
                  `${formatDateLocalized(
                    item.ratingEffectiveDate,
                    DATE_FORMAT,
                    language
                  )}<br />`
                )
              : null}
            <RatingCodeFunc item={item} />
            {item.ratingActionDescription
              ? ReactHtmlParser(
                  `${
                    displayLocalValues
                      ? item.ratingLocalActionDescription
                      : item.ratingActionDescription
                  }<br />`
                )
              : null}

            {item.ratingTypeDescription
              ? ReactHtmlParser(`${item.ratingTypeDescription}<br />`)
              : null}

            {item.recoveryRatingValue
              ? ReactHtmlParser(
                  `${item.recoveryRatingValue} ${
                    item.recoveryEstimate ? `${item.recoveryEstimate}%` : ''
                  }<br />`
                )
              : null}

            {recoveryEstimate
              ? ReactHtmlParser(`${recoveryEstimate}<br />`)
              : null}
            {item && item.correctionFlag
              ? ReactHtmlParser(
                  `Rating Correction <br /> (${formatDateLocalized(
                    item.changeDate,
                    DATE_FORMAT,
                    language
                  )})
            <br />`
                )
              : null}
          </React.Fragment>
        ))}
        {showRatingHistory ? (
          <span
            className="link--1 link--3"
            onClick={() => this.historyClick(rowIndex, ratableId)}
            onKeyUp={() => this.historyClick(rowIndex, ratableId)}
            role="presentation"
          >
            Rating History
          </span>
        ) : null}
      </>
    )
  }
}
export default RatingsCell
